import './App.css';
import Canvas from './components/canvas';
import CanvasPlayground from './components/CanvasPlayground';
import SegmentDemo from './components/SegmentDemo';
import { BrowserRouter as Router } from 'react-router-dom';
import LayoutSelection from './components/LayoutSelection';
import { Routes, Route } from 'react-router-dom';
import { CanvasProvider } from './contexts/CanvasContext';
import { UserProvider } from './contexts/UserContext'; // Import UserProvider
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const theme = createTheme({
  typography: {
    fontFamily: 'ProximaNova, sans-serif',
  },
});

function App() {

  return (
    <UserProvider>
      <CanvasProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <div className="App">

            <Router>
              <Routes>
                <Route path="/" element={<LayoutSelection />} />
                <Route path="/canvas" element={<Canvas />} />
                <Route path="/playground" element={<CanvasPlayground />} />
                <Route path="/segment-demo" element={<SegmentDemo />} />
              </Routes>
            </Router>

          </div>
        </ThemeProvider>
      </CanvasProvider>
    </UserProvider>

  );
}

export default App;
